import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { NovaOrb } from "../NovaOrb";

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] },
});

export const HeroSection = ({ onSeeAdapt }) => {
  return (
    <section className="relative min-h-screen flex flex-col" data-testid="hero-section">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_75%_20%,rgba(139,93,199,0.22),transparent_60%)]" />

      <div className="max-w-6xl w-full mx-auto px-6 sm:px-10 pt-7 flex items-center justify-between">
        <span className="font-display italic text-lg text-kaizen-text" data-testid="landing-logotype">
          Kaizen
        </span>
        <Link
          to="/login"
          data-testid="landing-login-link"
          className="text-sm text-kaizen-dim hover:text-kaizen-violetSoft transition-colors duration-300"
        >
          Log in
        </Link>
      </div>

      <div className="max-w-6xl w-full mx-auto px-6 sm:px-10 flex-1 grid grid-cols-1 md:grid-cols-2 items-center gap-10 py-14 md:py-0">
        <div className="flex justify-center md:hidden">
          <motion.div {...fadeUp(0)}>
            <NovaOrb size={140} />
          </motion.div>
        </div>

        <div>
          <motion.span
            {...fadeUp(0.05)}
            className="inline-flex items-center gap-1.5 text-xs px-3.5 py-1.5 rounded-full border border-kaizen-violet/30 text-kaizen-violetSoft bg-kaizen-violet/5"
            data-testid="hero-badge"
          >
            ✨ AI Fitness Coach for Busy Professionals
          </motion.span>

          <motion.h1
            {...fadeUp(0.15)}
            className="font-display italic text-4xl sm:text-5xl lg:text-6xl leading-[1.08] mt-5"
            data-testid="hero-headline"
          >
            Life isn't consistent.
            <br />
            Your progress can be.
          </motion.h1>

          <motion.p
            {...fadeUp(0.28)}
            className="text-base sm:text-lg text-kaizen-dim leading-relaxed mt-6 max-w-md"
            data-testid="hero-subcopy"
          >
            Most fitness apps expect perfect routines. Kaizen adapts your workouts, recovery and meals around your
            real schedule — so your busiest days never erase your progress.
          </motion.p>

          <motion.button
            {...fadeUp(0.4)}
            onClick={onSeeAdapt}
            data-testid="hero-cta-see-adapt"
            className="glow-cta mt-9 inline-flex items-center gap-2 bg-kaizen-violet text-[#140A24] text-sm font-semibold px-7 py-3.5 rounded-full hover:scale-[1.02] active:scale-[0.98] transition-transform duration-300"
          >
            See How Kaizen Adapts →
          </motion.button>
        </div>

        <div className="hidden md:flex justify-center">
          <NovaOrb size={280} />
        </div>
      </div>
    </section>
  );
};
